import { get } from "../api-service";

const listBrokers = (params) => {
  return get(`/brokers${params || ""}`);
};

export { listBrokers };
